import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import Navbar from '../../components/layout/Navbar/Navbar';
import Sidebar from '../../components/layout/Sidebar/Sidebar';
import CadastroCursosHeader from '../../components/features/cursos/CadastroCursosHeader';
import FormularioCurso from '../../components/features/cursos/FormularioCurso';
import { getCargoIdSidebar } from '../../constants/sidebarConfig';
import apiService from '../../services/api';
import styled from "styled-components";

const NAVBAR_HEIGHT = 65;
const SIDEBAR_WIDTH = 300;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  margin-top: 60px;
`;

const MainContent = styled.main`
  flex: 1;
  margin-left: ${SIDEBAR_WIDTH}px; 
  overflow-y: auto;
  height: calc(100vh - ${NAVBAR_HEIGHT}px);
`;

const DashCadastroCurso = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [editData, setEditData] = useState(null);
  const [user, setUser] = useState(null);
  const [sidebarItems, setSidebarItems] = useState([]);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await apiService.getCurrentUser();
        setUser(userData);
        const filteredItems = getCargoIdSidebar(userData.cargoId);
        setSidebarItems(filteredItems);
      } catch (err) {
        console.error('Erro ao buscar usuário:', err);
      }
    };

    fetchUser();
  }, []);

  useEffect(() => {
    const mode = searchParams.get('mode');
    
    if (mode === 'edit') {
      let cursoData = null;
      
      if (location.state?.editData) {
        cursoData = location.state.editData;
      }
      else {
        const storedData = sessionStorage.getItem('cursoEditData');
        if (storedData) {
          try {
            cursoData = JSON.parse(storedData);
          } catch (e) {
            console.error('Erro ao parsear dados de edição:', e);
          }
        }
      }
      
      if (cursoData) {
        setEditData(cursoData);
      } else {
        navigate('/DashCadastroCurso');
      }
    }
  }, [searchParams, location.state, navigate]);

  const handleVoltar = () => {
    navigate(location.state?.returnPath || '/Cursos');
  };

  return (
    <PageWrapper>
      <Navbar 
        onLogout={apiService.logout}
        showHome={true}
        showNotifications={true}
        showProfile={true}
        showLogout={true}
      />
      <ContentWrapper>
        <Sidebar items={sidebarItems} />
        <MainContent>
          <CadastroCursosHeader />
          <FormularioCurso 
            editData={editData}
            user={user}
            onVoltar={handleVoltar}
          />
        </MainContent>
      </ContentWrapper>
    </PageWrapper>
  );
};

export default DashCadastroCurso;
